import $ from "jquery";


$(function () {
	$('.placeholder-wrapper').click(function () {
		$('.placeholder-wrapper').addClass('d-none');
		$('.iframe-wrapper').removeClass('d-none');
    });
});
